// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__vjhJe","col":"styles_col__TDHNF","fulfillmentStatus":"styles_fulfillmentStatus__3J4Ll","emailCol":"styles_emailCol__1MacN"};